export default __webpack_public_path__ + "static/media/apple.92be7fd6.svg";